import { PixelPlaceholderLoader } from "@similarweb/ui-components";
import { FlexColumn, FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import styled from "styled-components";

export const StyledLoaderWrapper = styled(FlexColumn)`
    row-gap: 24px;
    height: 44px;
    justify-content: center;
`;

export const StyledPixelLoader = styled(PixelPlaceholderLoader)`
    border-radius: 50%;
`;

export const StyledListItem = styled(FlexRow)`
    column-gap: 8px;
    height: 44px;
`;
